(function () {
  const FLAG = {
    US: '🇺🇸', GB: '🇬🇧', CA: '🇨🇦', AU: '🇦🇺', DE: '🇩🇪', FR: '🇫🇷',
    NL: '🇳🇱', ES: '🇪🇸', IT: '🇮🇹', JP: '🇯🇵', BR: '🇧🇷', MX: '🇲🇽',
    GH: '🇬🇭', IN: '🇮🇳', SE: '🇸🇪', NO: '🇳🇴', DK: '🇩🇰', IE: '🇮🇪',
    NZ: '🇳🇿', ZA: '🇿🇦', IL: '🇮🇱', PT: '🇵🇹', CH: '🇨🇭', AT: '🇦🇹',
    BE: '🇧🇪', FI: '🇫🇮', KR: '🇰🇷', SG: '🇸🇬', AE: '🇦🇪', CN: '🇨🇳',
    PL: '🇵🇱', CZ: '🇨🇿', GR: '🇬🇷', TH: '🇹🇭', PH: '🇵🇭'
  };

  const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));

  function starsSvg(n, size = 14) {
    const filled = Math.round(n);
    let html = '';
    for (let i = 1; i <= 5; i++) {
      const fill = i <= filled ? 1 : 0.22;
      html += `<svg viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" style="opacity:${fill}"><path fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>`;
    }
    return html;
  }

  function checkIcon() {
    return `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4 4 10-10"/></svg>`;
  }

  function fmtDate(iso) {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function buildBars(counts, total) {
    const order = [5, 4, 3, 2, 1];
    return order.map((s) => {
      const c = counts[s] || 0;
      const pctRaw = total > 0 ? (c / total) * 100 : 0;
      // For tiny but non-zero counts, force a minimum visible bar of ~1.2%
      const pct = c > 0 ? Math.max(pctRaw, 1.2) : 0;
      const empty = c === 0 ? 'true' : 'false';
      return `
        <div class="solyn-reviews__bar">
          <span class="solyn-reviews__bar-label">${s}<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg></span>
          <div class="solyn-reviews__bar-track"><div class="solyn-reviews__bar-fill" data-empty="${empty}" style="width:${pct.toFixed(2)}%"></div></div>
          <span class="solyn-reviews__bar-count">${c.toLocaleString()}</span>
        </div>
      `;
    }).join('');
  }

  function truncateAtWord(text, maxChars) {
    if (!text || text.length <= maxChars) return { text: text || '', truncated: false };
    let cut = text.lastIndexOf(' ', maxChars);
    if (cut < maxChars * 0.6) cut = maxChars;
    return { text: text.slice(0, cut).trimEnd() + '…', truncated: true };
  }

  function buildCard(r, idx, truncateChars) {
    const flag = FLAG[r.country] || '';
    const trunc = truncateAtWord(r.body, truncateChars);
    return `
      <article class="solyn-reviews__card" data-review-index="${idx}">
        <h3 class="solyn-reviews__card-name">${escapeHtml(r.name)}</h3>
        <div class="solyn-reviews__card-meta">
          <span>${escapeHtml(fmtDate(r.date))}</span>
          ${flag ? `<span class="solyn-reviews__card-flag" aria-hidden="true">${flag}</span>` : ''}
          ${r.verified ? `<span class="solyn-reviews__verified">${checkIcon()} Verified</span>` : ''}
        </div>
        <div class="solyn-reviews__rating-row">
          <span>Rating: ${r.rating}/5</span>
          <span class="solyn-reviews__rating-stars" aria-label="${r.rating} out of 5">${starsSvg(r.rating, 14)}</span>
        </div>
        ${r.title ? `<h4 class="solyn-reviews__card-title">${escapeHtml(r.title)}</h4>` : ''}
        <p class="solyn-reviews__card-body">${escapeHtml(trunc.text)}</p>
        ${trunc.truncated ? `<button type="button" class="solyn-reviews__read-more" data-review-read="${idx}">See more</button>` : ''}
      </article>
    `;
  }

  function ensureReadModal(section) {
    let m = section.querySelector('[data-reviews-read-modal]');
    if (m) return m;
    m = document.createElement('div');
    m.className = 'solyn-reviews__read-modal';
    m.hidden = true;
    m.setAttribute('data-reviews-read-modal', '');
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.innerHTML = `
      <div class="solyn-reviews__modal-backdrop" data-reviews-read-close></div>
      <div class="solyn-reviews__read-content">
        <button type="button" class="solyn-reviews__modal-close" data-reviews-read-close aria-label="Close">
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="currentColor" d="M18.3 5.71L12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.3 19.71 2.88 18.29 9.18 12 2.88 5.71 4.3 4.29l6.29 6.3L16.88 4.3z"/></svg>
        </button>
        <div data-reviews-read-body></div>
      </div>
    `;
    section.appendChild(m);
    m.querySelectorAll('[data-reviews-read-close]').forEach((el) => {
      el.addEventListener('click', () => closeReadModal(section));
    });
    return m;
  }

  function openReadModal(section, review) {
    const modal = ensureReadModal(section);
    const body = modal.querySelector('[data-reviews-read-body]');
    const flag = FLAG[review.country] || '';
    body.innerHTML = `
      <h3 class="solyn-reviews__read-name">${escapeHtml(review.name)}</h3>
      <div class="solyn-reviews__card-meta">
        <span>${escapeHtml(fmtDate(review.date))}</span>
        ${flag ? `<span class="solyn-reviews__card-flag" aria-hidden="true">${flag}</span>` : ''}
        ${review.verified ? `<span class="solyn-reviews__verified">${checkIcon()} Verified</span>` : ''}
      </div>
      <div class="solyn-reviews__rating-row">
        <span>Rating: ${review.rating}/5</span>
        <span class="solyn-reviews__rating-stars">${starsSvg(review.rating, 16)}</span>
      </div>
      ${review.title ? `<h4 class="solyn-reviews__read-title">${escapeHtml(review.title)}</h4>` : ''}
      <p class="solyn-reviews__read-body">${escapeHtml(review.body)}</p>
    `;
    modal.hidden = false;
    document.body.classList.add('solyn-reviews-open');
  }

  function closeReadModal(section) {
    const modal = section.querySelector('[data-reviews-read-modal]');
    if (modal) modal.hidden = true;
    document.body.classList.remove('solyn-reviews-open');
  }

  async function loadReviews(section, dataNode) {
    // Try inline first
    let reviews = [];
    try {
      const inline = dataNode ? dataNode.textContent.trim() : '';
      if (inline) {
        const parsed = JSON.parse(inline);
        if (Array.isArray(parsed) && parsed.length > 0) reviews = parsed;
      }
    } catch (e) { /* ignore */ }

    // Otherwise fetch from asset URL
    if (reviews.length === 0) {
      const url = section.dataset.reviewsUrl;
      if (url) {
        try {
          const res = await fetch(url, { headers: { Accept: 'application/json' } });
          if (res.ok) reviews = await res.json();
        } catch (e) { console.warn('[reviews] fetch failed', e); }
      }
    }
    return Array.isArray(reviews) ? reviews : [];
  }

  async function init(section) {
    const dataNode = section.querySelector('[data-reviews-data]');
    const grid = section.querySelector('[data-reviews-grid]');
    const empty = section.querySelector('[data-reviews-empty]');
    const loadWrap = section.querySelector('[data-reviews-load-wrap]');
    const loadBtn = section.querySelector('[data-reviews-load]');
    const search = section.querySelector('[data-reviews-search]');
    const sort = section.querySelector('[data-reviews-sort]');
    const writeBtn = section.querySelector('[data-reviews-write]');
    const modal = section.querySelector('[data-reviews-modal]');
    const form = section.querySelector('[data-reviews-form]');
    const closes = section.querySelectorAll('[data-reviews-close]');
    const ratingPicker = section.querySelector('[data-rating-picker]');
    const ratingInput = section.querySelector('[data-form-rating-input]');
    const productInput = section.querySelector('[data-form-product]');
    const successEl = section.querySelector('[data-reviews-success]');
    const errorEl = section.querySelector('[data-reviews-error]');

    if (!grid) return;

    const reviews = await loadReviews(section, dataNode);
    if (!reviews.length) {
      if (empty) empty.hidden = false;
      return;
    }

    const truncateChars = parseInt(section.dataset.truncate, 10) || 220;

    // Counts (always derived from data)
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    for (const r of reviews) {
      const k = Math.round(r.rating);
      if (counts[k] != null) counts[k]++;
    }
    const total = reviews.length;
    const weighted = counts[5]*5 + counts[4]*4 + counts[3]*3 + counts[2]*2 + counts[1]*1;
    const avg = total > 0 ? (weighted / total) : 0;
    // 4.99 should display as 4.9 (truncate, not round) — feels more honest
    const avgDisplay = (Math.floor(avg * 10) / 10).toFixed(1);

    section.querySelector('[data-reviews-avg]').textContent = avgDisplay;
    section.querySelector('[data-reviews-avg-stars]').innerHTML = starsSvg(avg, 22);
    section.querySelector('[data-reviews-total]').textContent = total.toLocaleString();
    section.querySelector('[data-reviews-bars]').innerHTML = buildBars(counts, total);

    if (productInput) productInput.value = section.dataset.productName || '';

    const pageSize = parseInt(section.dataset.pageSize, 10) || 12;
    let shown = pageSize;
    let query = '';
    let sortBy = 'date';

    function getView() {
      let list = reviews.slice();
      if (query) {
        const q = query.toLowerCase();
        list = list.filter((r) =>
          (r.name || '').toLowerCase().includes(q) ||
          (r.title || '').toLowerCase().includes(q) ||
          (r.body || '').toLowerCase().includes(q)
        );
      }
      list.sort((a, b) => {
        const dateCmp = a.date < b.date ? 1 : (a.date > b.date ? -1 : 0);
        if (sortBy === 'rating-desc') return (b.rating - a.rating) || dateCmp;
        if (sortBy === 'rating-asc') return (a.rating - b.rating) || dateCmp;
        return dateCmp;
      });
      return list;
    }

    let currentList = [];

    function render() {
      currentList = getView();
      const slice = currentList.slice(0, shown);
      grid.innerHTML = slice.map((r, i) => buildCard(r, i, truncateChars)).join('');
      empty.hidden = currentList.length > 0;
      loadWrap.hidden = shown >= currentList.length;
    }

    grid.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-review-read]');
      if (!btn) return;
      const idx = parseInt(btn.dataset.reviewRead, 10);
      const review = currentList[idx];
      if (review) openReadModal(section, review);
    });

    if (search) {
      search.addEventListener('input', () => {
        query = search.value.trim();
        shown = pageSize;
        render();
      });
    }
    if (sort) {
      sort.addEventListener('change', () => {
        sortBy = sort.value;
        render();
      });
    }
    if (loadBtn) {
      loadBtn.addEventListener('click', () => {
        shown += pageSize;
        render();
      });
    }

    render();

    // Write-review modal
    function openModal() {
      modal.hidden = false;
      document.body.classList.add('solyn-reviews-open');
      const firstField = modal.querySelector('input[name="contact[name]"]');
      if (firstField) setTimeout(() => firstField.focus(), 60);
    }
    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('solyn-reviews-open');
    }

    if (writeBtn) writeBtn.addEventListener('click', openModal);
    closes.forEach((el) => el.addEventListener('click', closeModal));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (modal && !modal.hidden) closeModal();
        closeReadModal(section);
      }
    });

    // Rating picker
    if (ratingPicker && ratingInput) {
      const stars = ratingPicker.querySelectorAll('.solyn-reviews__rating-star');
      function setRating(val) {
        ratingInput.value = val;
        stars.forEach((s) => {
          const v = parseInt(s.dataset.value, 10);
          s.classList.toggle('is-active', v <= val);
          s.setAttribute('aria-checked', v === val ? 'true' : 'false');
        });
      }
      stars.forEach((s) => {
        s.addEventListener('click', () => setRating(parseInt(s.dataset.value, 10)));
        s.addEventListener('mouseenter', () => {
          const v = parseInt(s.dataset.value, 10);
          stars.forEach((other) => {
            const ov = parseInt(other.dataset.value, 10);
            other.classList.toggle('is-active', ov <= v);
          });
        });
      });
      ratingPicker.addEventListener('mouseleave', () => {
        const cur = parseInt(ratingInput.value || 0, 10);
        stars.forEach((s) => {
          const v = parseInt(s.dataset.value, 10);
          s.classList.toggle('is-active', v <= cur);
        });
      });
    }

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        successEl.hidden = true;
        errorEl.hidden = true;
        if (!ratingInput.value) {
          errorEl.textContent = 'Please select a star rating.';
          errorEl.hidden = false;
          return;
        }
        const submitBtn = form.querySelector('.solyn-reviews__submit');
        submitBtn.disabled = true;
        const originalLabel = submitBtn.textContent;
        submitBtn.textContent = 'Submitting…';
        try {
          const fd = new FormData(form);
          const res = await fetch('/contact', {
            method: 'POST', body: fd, headers: { Accept: 'application/json' }
          });
          if (!res.ok && res.status !== 0) throw new Error('HTTP ' + res.status);
          successEl.hidden = false;
          form.reset();
          if (ratingPicker) {
            ratingPicker.querySelectorAll('.solyn-reviews__rating-star').forEach((s) => s.classList.remove('is-active'));
          }
        } catch (err) {
          console.warn('[reviews] submit error', err);
          errorEl.textContent = 'Something went wrong. Please try again or email us directly.';
          errorEl.hidden = false;
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector('[data-reviews]');
    if (sec) init(sec);
  });
})();
